
let BaseTest = require('@/mixins/Forms/2016/BaseTest')

module.exports = {

    mixins: [BaseTest],

    data() {
        return {
            testResult: 0,
            spaces: [],
        }
    },

    mounted() {
        this.loadFormData();
        this.resolveTest();
    },

    methods: {

        constructionInspection() {
            var checkbox_1 = $('input[name="verify_the_demand_responsive_control_is_capable"]:checked').val() ? true : false;
            var checkbox_2 = $('input[name="demand_response_signal_is_received_from_another_device"]:checked').val() ? true : false;
            return checkbox_1 && checkbox_2;
        },

        removeSpace(){
            if(this.canRemoveSpaces) {
                this.spaces.pop();
            }
        },
        loadFormData() {
            axios.get(`${window.location.href}/data`).then(response => {
                if (response.data.data) {
                    for (var i = 0; i < response.data.data.number_of_spaces; i++) {
                        this.loadSpaceData(i, response.data.data);
                    }
                }
                if (this.spaces.length == 0) {
                    this.addSpace();
                }
            })
        },
    },


    computed:{
        canRemoveSpaces(){
            return this.spaces.length > 1;
        }
    }
}
